import { useTranslation } from 'react-i18next'

import { ButtonSelect } from '../../Select'

import { getUserRoleSelectOptions } from './UserRoleSelect.utils'

function UserRoleSelect({ options = null, ...restProps }) {
  const { t } = useTranslation()

  const selectOptions = options ?? getUserRoleSelectOptions(t)

  return (
    <ButtonSelect
      {...restProps}
      listProps={{
        headerProps: {
          Search: null,
        },
      }}
      options={selectOptions}
    />
  )
}

export default UserRoleSelect
